module.exports = __webpack_public_path__ + "media/images/husay-6fdfe2b6ba7adccbb22b966edacb47c8.png";